import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from '../components/header';
import GoToTop from '../components/go-to-top';
import FooterComponents from '../components/footerComponents';
import '../common/style/main.styl';
import favicon from '../../static/favicon.png'

const TemplateWrapper = ({children, data}) =>
{
	let lang = 'es';
	if ("undefined" != typeof(window)) {
		lang = window.location.pathname.split('/')[1];
	}

	const dataProducts = data.allBicenturyNavbar.edges.map(x => x).filter(x => x.node.lang === lang)[0].node;
	const translations = data.allBicenturyTranslations.edges.map(x => x).filter(x => x.node.lang === lang)[0].node;

	return (
		<div>
			<Helmet
				title="Gatsby Default Starter"
				meta={[
					{name: 'description', content: 'Bicentury'},
					{name: 'keywords', content: 'Bicentury'},
				]}>
				<link data-is-minisite-asset="true" href="https://fonts.googleapis.com/css?family=Montserrat:200,300,400,500,600,700|Oswald:300,500,700|Playfair+Display" rel="stylesheet"></link>
				<link data-is-minisite-asset="true" rel="shortcut icon" type="image/png" href={favicon}></link>
			</Helmet>

			<Header lang={lang}
							data={dataProducts}
							translations={translations}
							/>

			<main>
				{children()}
			</main>

			
			<FooterComponents 
				lang={lang}
				translations={translations}
				dataProducts={dataProducts}
			/>

			<GoToTop />	

			<script data-is-minisite-asset="true" src="https://ajax.googleapis.com/ajax/libs/jquery/2.2.2/jquery.min.js"></script>
		</div>
	);
};

TemplateWrapper.propTypes = {
	children: PropTypes.node
};

export default TemplateWrapper

export const query = graphql`
query NavQuery {
	allBicenturyTranslations {
    edges {
      node {
        id
        lang
        btnBack
        gustazos
        products
        company
        contact
        legal
        collaborate
        allFlavors
        followus
        menu
        languages
				attitude_title
				attitude_text
				attitude_hashtags
				btnAccept
				cookielayer_title
				cookielayer_text
				cookielayer_acceptall
				cookielayer_reject
				cookielayer_configure
				cookiecp_title
				cookiecp_text
				cookiecp_firsts_paragraphs {
					title
					text
				}
				cookiecp_own_title  
				cookiecp_own_text
				cookiecp_tech_title
				cookiecp_tech_text
				cookiecp_third_title
				cookiecp_third_text
				cookiecp_analytics_title
				cookiecp_analytics_text
				cookiecp_analytics_name
				cookiecp_last_paragraphs {
					title
					text
				}
      }
    }
  }
	allBicenturyNavbar {
    edges {
      node {
        id
        title
        lang
				navbarItems {
					top_left {
						text
						link
						linktype
					}
					top {
						text
						link
						linktype
					}
					bottom {
						text
						link
						linktype
					}
				}
				footerPages {
          id
          title
          type
          lang
          path
					userDefinedId
        }
        products {
          id
          title
					lang
					path
        }
      }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js